import SendReview from './send_review'
import { getValues } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { getFullName } from 'griffin'
import { getLocationGlimpse } from 'lib/glimpse'
import { getCampaignSelector } from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'
import { glimpseRoute } from 'lib/route_utils'
import { push } from 'react-router-redux'

import {
  startIFrameLoad,
  finishIFrameLoad,
  reportErrorFromIFrame,
  failedIFrameLoad,
  startIFrameSend,
  finishIFrameSendSuccessfully,
} from 'redux/modules/send_iframe'

import { sendDonationEmail } from 'redux/modules/notifications'

import { loginUrlSelector } from 'redux/selectors/login'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let amount, anonymous, note
  if (state.server.isReturningFromWallet) {
    amount = state.preloadSendValues.amount
    anonymous = state.preloadSendValues.anonymous
    note = state.preloadSendValues.note
  } else {
    const sendFormData = getValues(state.form.send) || {}
    amount = sendFormData.amount
    anonymous = sendFormData.anonymous
    note = sendFormData.note
  }

  return {
    title: campaign.title,
    ownerDisplayName: getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    }),
    currency: campaign.currency,
    loadingIFrame: state.send_iframe.iframe_loading,
    loadingDone: state.send_iframe.loading_done,
    iFrameError: state.send_iframe.iframe_error,
    sendDone: state.send_iframe.send_done,
    gsBypass: state.send_iframe.gs_bypass,
    amount,
    anonymous,
    note,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onInit() {
      dispatch(startIFrameLoad())
    },

    onIframeMessage(eventName, payload) {
      // eslint-disable-next-line
      switch (eventName) {
        case 'pageHasFailed':
          dispatch(failedIFrameLoad())
          break
        case 'previewPageSendAction': {
          dispatch(startIFrameSend())
          if (ownProps.onScrollTop) {
            ownProps.onScrollTop()
          }
          break
        }
        case 'successPageRendered': {
          const { campaignId } = payload
          const { amount, currency, paymentId } = payload.data
          dispatch(
            finishIFrameSendSuccessfully(
              campaignId,
              amount,
              currency,
              paymentId
            )
          )
          dispatch(sendDonationEmail(campaignId, paymentId))
          break
        }

        case 'sessionTimerOverlayRendered':
          dispatch((_, getState) => {
            location.href = loginUrlSelector({
              returnUri: window.location.href,
            })(getState())
          })
          break
        case 'asyncErrorMessage':
        case 'errorMessage':
          if (payload && payload.error) {
            dispatch(
              reportErrorFromIFrame(payload.error.message || payload.error)
            )
          }
          break
        case 'noCurrencyBalanceError':
          dispatch(push({ pathname: glimpseRoute('send', 'nochipin') }))
      }

      if (payload.toggleLoading === true) {
        dispatch(startIFrameLoad())
      } else if (payload.toggleLoading === false) {
        dispatch(finishIFrameLoad())
      }
    },
  }
}

// check for the initial query params here
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    preventNavigation(SendReview, (props, nextLocation) => {
      return props.sendDone && getLocationGlimpse(nextLocation) === 'send'
    })
  )
)
